import { getBookingsRouterStore } from '../store';
import { mutatorAction } from 'satcheljs';
import type { BookingsRoute } from 'bookingsv2-constants/lib/bookingsRouteConstants';

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const changeCurrentRoute: (currentRoute: BookingsRoute) => void = mutatorAction(
    'UPDATE_CURRENT_ROUTE',
    function changeCurrentRoute(currentRoute: BookingsRoute): void {
        /**
         * We can't directly call setNavigationStart(performance.now()) from
         * changeCurrentRoute mutator itself because it's used in bookingsv2-routes
         */
        getBookingsRouterStore().currentRoute = currentRoute;
    }
);

export default changeCurrentRoute;
